import axios from "axios";
import { API_HOST } from "@/core/variables";
import { AutoCompleteKeywordCreate, AutoCompleteKeywordUpdate } from "@/model";

class AutoCompleteKeywordRepository {
    findByKeyword = async (
        autocompleteToken: string,
        query: string,
    ) => {
        return axios
            .get(`${API_HOST}/v1/service/autocompletes/${autocompleteToken}`, {
                params: {
                    q: query,
                }
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    find = async (
        agentId: number,
        autocompleteId: string ,
        page: number,
        size: number,
        order: 'asc' | 'desc',
        keyword?: string,
    ) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/keywords`, {
                params:{
                    page: page,
                    size: size,
                    keyword: keyword,
                    sort_key: 'keyword',
                    order: order,
                }
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    create = async (
        agentId: number,
        autocompleteId: string,
        form: AutoCompleteKeywordCreate,
    ) => {
        return axios
            .post(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/keyword`, {
                ...form,
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    update = async (
        agentId: number,
        autocompleteId: string,
        autocompleteKeywordId: string,
        form: AutoCompleteKeywordUpdate,
    ) => {
        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/keyword/${autocompleteKeywordId}`, {
                ...form,
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete = async (
        agentId: number,
        autocompleteId: string,
        autocompleteKeywordId: string,
    ) => {
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/keyword/${autocompleteKeywordId}`)
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteMany = async (
        agentId: number,
        autocompleteId: string,
        ids?: string[],
        keyword?: string
    ) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => {
            params.append("ids", id);
        });
        if (keyword)
            params.append("keyword", keyword);
        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/keyword`, {
                params: params
            })
            .then(response => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    import  = async (
        agentId: number,
        autocompleteId: string,
        file: File,
        isCleanImport?: boolean,
    ) => {
        const form = new FormData();
        const is_clean_import = isCleanImport ? '1' : '0';
        form.append("is_clean_import", is_clean_import);
        form.append("file", file);

        return axios
            .put(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/import`, form)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    export = (agentId: number, autocompleteId: string) => {
        window.open(`${API_HOST}/v1/agents/${agentId}/autocompletes/${autocompleteId}/export`);
    };
}

const autoCompleteKeywordRepository = new AutoCompleteKeywordRepository();
export default autoCompleteKeywordRepository;